import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field, withFormik } from 'formik';
import { withRouter } from 'react-router-dom';
import * as yup from 'yup';
import axios from 'axios';
import { compose } from 'redux';

import TutoriumInput from '../../form/TutoriumInput';
import AuthSubmitButton from '../common/AuthSubmitButton';

import Alert from '../../common/Alert';

const mapPropsToValues = () => ({ password: '', passwordConfirmation: '' });

const validationSchema = yup.object().shape({
  password: yup.string().required(),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required(),
});

const handleSubmit = async (values, bag) => {
  bag.setSubmitting(true);

  try {
    const response = await axios.post('/api/v1/auth/resetPassword', {
      token: bag.props.token,
      password: values.password,
    });

    if (response.data.success) {
      bag.props.history.push('/auth');
    } else {
      bag.setErrors({ summary: response.data.errorMessage });
    }
  } catch (e) {
    bag.setErrors({ summary: e.response.data.errorMessage });
  }

  bag.setSubmitting(false);
};

const ResetPasswordForm = props => (
  <Form noValidate>
    {props.errors.summary && <Alert message={props.errors.summary} isError isSmall />}
    <Field type="password" name="password" placeholder="New Password" component={TutoriumInput} />
    <Field type="password" name="passwordConfirmation" placeholder="Confirm New Password" component={TutoriumInput} />
    <AuthSubmitButton title="Reset password" isSubmitting={props.isSubmitting} />
  </Form>
);

ResetPasswordForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired, // TODO
};

export default compose(
  withRouter,
  withFormik({
    mapPropsToValues,
    validationSchema,
    handleSubmit,
  }),
)(ResetPasswordForm);
